import {
  AGC_APP_CODE,
  AIMS_APP_CODE,
  SRP_APP_CODE,
  VR_APP_CODE,
} from "app/farmer360/constants/common";
import { APP_CODE_TYPE } from "app/farmer360/models/auth";

const getClientCode = (appCode?: boolean | APP_CODE_TYPE) => {
  if (appCode === "02") return AIMS_APP_CODE;
  if (appCode === "03") return VR_APP_CODE;
  if (appCode === "05") return AGC_APP_CODE;
  if (appCode === "06") return SRP_APP_CODE;
  return process.env.APP_CODE;
};

export default getClientCode;
